// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-ca-service-dialog.common-dialog[data-v-f9f7b5d2] .el-dialog{width:var(--common-dialog-width)}.add-ca-service-dialog.common-dialog .el-form[data-v-f9f7b5d2]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
